module.exports = __webpack_public_path__ + "img/404-image-1.dd96f23a.png";